import { render, staticRenderFns } from "./PackagesAdd.vue?vue&type=template&id=fd587314&"
import script from "./PackagesAdd.vue?vue&type=script&lang=js&"
export * from "./PackagesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports